import * as React from 'react';
export const boletoSvg = React.forwardRef(function boletoSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 23.545V8.273h24v15.272H4ZM26.473 9.8H5.527v12.218h20.946V9.8Zm-16.146 1.745v8.728H7.055v-8.728h3.272Zm3.273 0v8.728h-2.4v-8.728h2.4Zm4.364 0v8.728H14.69v-8.728h3.273Zm1.963 0v8.728h-.654v-8.728h.654Zm2.4 0v8.728H20.8v-8.728h1.527Zm2.4 0v8.728H23.2v-8.728h1.527Z',
      fill: '#000',
    }),
  );
});
boletoSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var boleto = {
  category: 'brand',
  colorable: false,
  name: 'boleto',
  svg: boletoSvg,
};
